import React from 'react'
import Helmet from 'react-helmet'
import { graphql, useStaticQuery } from 'gatsby'
import { HTMLContent } from '../components/Content'
import { BlogPostTemplate } from './blog-post'

export const RuntimeBlog = (props) => {
  const { blogs } = useStaticQuery(
    graphql`
        query AllBlogs {
            blogs: allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "blog-post"}}}) {
            edges {
                node {
                fields {
                    slug
                }
                id
                html
                frontmatter {
                  date(formatString: "MMMM DD, YYYY")
                  title
                  description
                  tags
                }
                }
            }
        }
    }
    `);
  let blog = {
    html: '',
    frontmatter: {
      title: '',
      description: '',
      tags: []
    }
  };
  blogs.edges.forEach((edge) => {
    if (edge.node.id === props.blogId) blog = edge.node;
  });
  return (
    <BlogPostTemplate
      content={blog.html}
      contentComponent={HTMLContent}
      description={blog.frontmatter.description}
      helmet={
        <Helmet titleTemplate="%s | Blog">
          <title>{`${blog.frontmatter.title}`}</title>
          <meta
            name="description"
            content={`${blog.frontmatter.description}`}
          />
        </Helmet>
      }
      tags={blog.frontmatter.tags}
      title={blog.frontmatter.title}
    />
  )
}
